import React from "react";
import {
  Icon,
  Text,
  LinkText,
  theme,
  useModal,
  Heading,
} from "@clearabee/ui-library-native";
import { Image } from "components/Image/Image";
import {
  ids,
  styles,
} from "../../containers/ProductDetails/ProductDetails.styles";
import { ButtonLink } from "components/Core/ButtonLink/ButtonLink";
import { useTranslation } from "react-i18next";
import { Platform, View } from "react-native";
import { Anchor } from "components/Core/Anchor/Anchor";
import placeholderImage from "lib/images/placeholder.png";
import { CatalogueItem } from "lib/types";
import { useBasket } from "@clearabee/ui-sdk";

type UseSuccessModalReturn = [
  (props: { product: CatalogueItem }) => React.ReactElement,
  ReturnType<typeof useModal>[1],
];

export const useSuccessModal = (): UseSuccessModalReturn => {
  const [Modal, showModal] = useModal({ defaultVisible: false });
  const [translate] = useTranslation();
  const { basket } = useBasket();

  return [
    ({ product }) => (
      <Modal
        color="light"
        width={550}
        styles={{ minHeight: 420 }}
        actions={
          <>
            <View
              style={styles.modalButtonsContainer}
              dataSet={{ media: ids.modalButtonsContainer }}
            >
              <View
                style={styles.modalCheckoutButtonWrapper}
                dataSet={{ media: ids.modalCheckoutButtonWrapper }}
              >
                <Anchor routeName="Basket" onClick={() => showModal(false)}>
                  <LinkText
                    textStyles={{ fontSize: theme.spacing.small }}
                    underline
                  >
                    {translate(
                      "hwa.screens.productDetails.successModal.viewBasket",
                    )}
                  </LinkText>
                </Anchor>
              </View>

              <ButtonLink
                routeName="Checkout"
                color="positive"
                size="medium"
                onPress={() => Platform.OS !== "web" && showModal(false)}
              >
                <View style={{ display: "flex", flexDirection: "row" }}>
                  <Icon.PadLock size="medium" color="light" />
                  <Text
                    color="light"
                    styles={{ marginLeft: theme.spacing.small }}
                  >
                    {!basket?.totalCost
                      ? translate(
                          "hwa.screens.productDetails.successModal.noChargeProceed",
                        )
                      : translate(
                          "hwa.screens.productDetails.successModal.proceed",
                        )}
                  </Text>
                </View>
              </ButtonLink>
            </View>

            {/* TODO: Re-add once we support multiple services in one basket */}
            {/* <Anchor routeName="ServicePage" params={{ categorySku }}>
              <LinkText underline>
                {translate(
                  "hwa.screens.productDetails.successModal.continueShopping",
                )}
              </LinkText>
            </Anchor> */}
          </>
        }
      >
        <Image
          style={styles.modalImageWrap}
          resizeMode="contain"
          source={product.img ?? placeholderImage}
        />
        <Heading styles={styles.modalHeading} fontSize="large" color="brand">
          {product.title}
        </Heading>
        <Text fontSize="base">
          {translate("hwa.screens.productDetails.successModal.addedToBasket")}
        </Text>
      </Modal>
    ),
    showModal,
  ];
};
